module.exports = __webpack_public_path__ + "img/9-1_06.80bf683b.jpg";